import { CartLinesUpdateEvent } from '@shopify/events';

/* ---- cart: switch a line between one-time, 30-day and 90-day supply (snippets/lp-cart-sub) ----
   cart/change.js only accepts `line` (1-based) when selling_plan is set; null removes the plan.
   data-q on the button is the new quantity (a 90-day supply is 3 cartridges per delivery). */
(()=>{
const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
async function setPlan(box,plan,qty,el){
  if(box.getAttribute('aria-busy')==='true')return;
  box.setAttribute('aria-busy','true');
  const err=box.querySelector('.lp-csub__err');if(err)err.hidden=true;
  const key=box.dataset.key,line=Number(box.dataset.line);
  const sectionIds=[...document.querySelectorAll('cart-items-component')].map(x=>x.dataset.sectionId).filter(Boolean);
  const deferred=CartLinesUpdateEvent.createPromise();
  el.dispatchEvent(new CartLinesUpdateEvent({action:'update',context:'cart',lines:[{id:key,quantity:qty}],promise:deferred.promise}));
  try{
    const r=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line,quantity:qty,selling_plan:plan,sections:sectionIds.join(','),sections_url:window.location.pathname})});
    const res=await r.json();
    if(!r.ok||res.status)throw new Error(res.description||res.message||'Cart update failed');
    deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(res),detail:{items:res.items,source:'lp-cart-sub',sourceId:'lp-cart-sub',itemCount:res.item_count,sections:res.sections,didError:false}});
  }catch(error){
    console.warn('[lp-cart-sub]',error);deferred.reject(error);
    box.removeAttribute('aria-busy');if(err)err.hidden=false;
  }
}
document.addEventListener('click',e=>{
  const b=e.target.closest('.lp-csub [data-act]');if(!b)return;
  e.preventDefault();
  const box=b.closest('.lp-csub');const qty=Number(b.dataset.q||box.dataset.qty||1);
  if(b.dataset.act==='plan')setPlan(box,Number(b.dataset.plan),qty,b);
  else if(b.dataset.act==='one')setPlan(box,null,qty,b);
});
/* the drawer slides over the page (assets/lp-cart-sub.css): a click on the dim scrim closes it */
document.addEventListener('click',e=>{const d=document.getElementById('cart-drawer');if(d&&typeof d.close==='function'&&d.querySelector('dialog[open]')&&e.target.classList&&e.target.classList.contains('page-wrapper'))d.close()});
})();
